<template>
    <div class="container">
        <div class="row justify-content-md-center main">
            <div class="col-12">
                <h1 class="jumbotron-heading">Monitor Starten</h1>
                <p class="lead">
                    Hier kannst du die Haltestelle und ein paar weitere Einstellungen wählen. Sobald eine Haltestelle ausgewählt wurde kannst du
                    auf <em>Start</em> klicken und gelangst zum Monitor.
                    <small>Die Einstellungen werden in der URL abgelegt, du kannst also auch die URL kopieren und auf einem anderen PC öffnen
                    um zur gleichen Seite zu gelangen.</small></p>

                    <hr />

                <h2 class="text-muted"><small>Einstellungen</small></h2>
                    <div class="form-group row">
                                        <label for="haltestelle" class="col-sm-3 col-form-label">Haltestelle</label>
                                        <div class="col-sm-9">
                                        <vue-bootstrap-typeahead
                                            name="haltestelle"
                                            placeholder="Haltestellenname"
                                            v-model="query"
                                            :data="searchStops"
                                            :serializer="item => item.suggest_name"
                                            @hit="selectedStop = $event"
                                            :minMatchingChars="0">
                                                <template slot="suggestion" slot-scope="{ data }">
                                                    <span>{{data.object}}</span>&nbsp;<small>{{ data.mainLoc }}</small>
                                                </template>
                                            </vue-bootstrap-typeahead>
                                            </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="aktualisierung" class="col-sm-3 col-form-label">Aktualisierung</label>
                                        <div class="col-sm-3">
                                            <input name="aktualisierung" class="form-control" placeholder="60" v-model="refresh" type="number">
                                        </div>
                                        <div class="col-sm-6 col-form-label">Sekunden</div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="custom-control custom-switch col-sm-4 offset-sm-1">
                                        <input type="checkbox" class="custom-control-input" v-model="kiosk" id="kiosk">
                                        <label class="custom-control-label" for="kiosk">Kioskmodus</label>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-sm-12">
                                            <a role="button" v-bind:class="{disabled: !ready}" v-on:click="startMonitor" class="btn btn-primary btn-lg launch">Start</a>
                                        </div>
                                    </div>
            </div>
        </div>
    </div>
</template>

<script>
var _ = require('lodash')

export default {
  name: 'SettingsElement',
  data: () => {
    return {
      query: '',
      searchStops: [],
      selectedStop: null,
      refresh: 60,
      kiosk: false,
      ready: false
    }
  },
  methods: {
    async getStops (query) {
      let url = `https://www.bayern-fahrplan.de/autosuggest?anyObjFilter_sf=2&odvSortingMacro=beg&coordOutputFormat=WGS84%5BDD.DDDDD%5D&locationServerActive=1&outputFormat=JSON&type_sf=any&name_sf=${query}`
      const res = await fetch(url)
      const response = await res.json()

      if (Object.keys(response.stopFinder.points).length === 1 && Object.keys(response.stopFinder.points).length > 0) { this.searchStops = [response.stopFinder.points.point] } else { this.searchStops = response.stopFinder.points }

      this.searchStops.forEach(function (element) {
        element.suggest_name = element.name.replace(/,/g, '')
      })
    },

    startMonitor (event) {
      if (this.selectedStop != null) {
        this.$router.push({ path: '/abfahrten', query: { id: this.selectedStop.stateless, refresh: this.refresh, kiosk: this.kiosk } })
      }
    }
  },
  watch: {
    query: _.debounce(function (q) { this.getStops(q) }, 500),
    selectedStop: function (stop) { if (stop != null) { this.ready = true } else { this.ready = false } }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
    margin-top: 5em;
    display: flex;
    align-items: center;
    text-align: left;
}

.launch {
    width: 100%;
}
.launch a {
    color: #ffffff!important;
}

.launch a:hover {
    color: #ffffff!important;
}

</style>
